import {initWebComponent} from "@/helpers/web-component-helper";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {setActiveFilter} from "@/helpers/filter/filter-helper";
import {getFilters} from "@/http/services/http-services-filter";
import {removeAllActiveClasses} from "@/helpers/layer-menu-helper";
import {removeClassBySelector} from "@/helpers/element-helper";

export class HeaderFilterItemComponent extends HTMLElement {
    constructor(){
        super();

        const bookmarkPresentationID = this.getAttribute('data-bookmark-presentation-id')
        const presentationID = this.getAttribute('data-presentation-id')
        const formID = this.getAttribute('data-form-id')
        const label = this.getAttribute('data-label')

        const template = document.createElement('template');
        template.innerHTML = `<li class="dropdown-item cursor-pointer">${label}</li>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            removeAllActiveClasses()

            removeClassBySelector('.btn-filter', 'active')

            setActiveFilter(bookmarkPresentationID, presentationID, formID)
        })
    }
}

